import { StatsInfo } from "src/components/compounds/GameStats/stat-info-type";
import { GridItem, PlayerWithLinkColumn, PlayerWithoutLinkColumn } from "../common-columns";
import { eventDateFormatter, inningsFormatter, percentFormatter, rangeFormatter } from "../formatters";

export interface FieldingCatchingFormattedRow {
  player: {
    id: string;
    teamID: string;
    name: string;
    status: string;
  };
  INN: number;
  PB: number;
  SB: number;
  ["SB-ATT"]: string;
  CS: number;
  ["CS%"]: number;
  PIK: number;
  CI: number;
}

export const catchersGridDataFormatted = (grid: GridItem[]): FieldingCatchingFormattedRow[] => {
  return grid
    .filter(({ defense }) => defense && defense["IC:C"] !== 0)
    .map(({ person_id, team_id, name, eventID, date, defense }) => {
      return {
        player: {
          id: person_id,
          teamID: team_id,
          name,
          eventID,
          status: "active",
        },
        // Read by the per-game Date column; undefined (and ignored) in season/box-score views.
        event: date,
        INN: defense["IC:C"],
        PB: defense["PB:C"],
        SB: defense["SB:C"],
        "SB-ATT": `${defense["CS:C"]}-${defense["SBATT:C"]}`,
        CS: defense["CS:C"],
        "CS%": defense["CS:C%"],
        PIK: defense["PIK:C"],
        CI: defense["CI:C"],
      };
    });
};

export const CoreFieldingCatching = (includeSort: boolean): StatsInfo[] => [
  {
    name: "INN",
    field: "INN",
    def: "Innings played as catcher",
    valueFormatter: inningsFormatter,
    columnProps: {
      ...(includeSort ? { sort: "desc" } : {}),
    },
  },
  { name: "PB", field: "PB", def: "Passed balls allowed" },
  { name: "SB", field: "SB", def: "Stolen bases allowed" },
  {
    name: "SB-ATT",
    field: "SB-ATT",
    def: "Stolen bases - Stealing attempts",
    valueFormatter: rangeFormatter,
  },
  { name: "CS", field: "CS", def: "Runners caught stealing" },
  {
    name: "CS%",
    field: "CS%",
    def: "Runners caught stealing percentage",
    valueFormatter: percentFormatter,
  },
  { name: "PIK", field: "PIK", def: "Runners picked off" },
  { name: "CI", field: "CI", def: `Batter advances on catcher's interference` },
];

export const FieldingCatching: StatsInfo[] = [PlayerWithLinkColumn, ...CoreFieldingCatching(true)];

export const EventFieldingCatching: StatsInfo[] = [
  {
    name: "Date",
    field: "event",
    valueFormatter: eventDateFormatter,
    sort: "asc",
    columnProps: {
      width: 100,
      pinned: true,
      cellStyle: { textAlign: "left" },
    },
  },
  {
    name: "OPPONENT",
    field: "opponent",
    columnProps: {
      width: 260,
      cellStyle: { textAlign: "left" },
      headerClass: "left-aligned-column-header",
    },
  } as StatsInfo,
  ...CoreFieldingCatching(false),
];

export const GameFieldingCatching: StatsInfo[] = [PlayerWithoutLinkColumn, ...CoreFieldingCatching(true)];
